import React from "react";
import { backToStartAction } from "ouisys-engine/moFlow";
import { tracker } from "ouisys-engine/utilities/tracker";
import { IKeywordShortcode, MOLink, Link } from "ouisys-component-library";
import { injectIntl, FormattedMessage } from "../../localization/index";
import { useDispatch } from "../../__doNotModify/store";

type MOProps = IKeywordShortcode & {
  intl: any;
  operator: string;
};

const MO = ({ keyword, shortcode, operator }: MOProps) => {
  const dispatch = useDispatch();
  const backToStart = () => dispatch(backToStartAction());
  // const keywordOverride = "DA Pošljite to sporočilo, da potrdite svoj dostop";
  const keywordOverride = "DA";
  const A1shortCodeOveride = "60609090";

  const shortCodeOveride =
    operator === "SI_A1" ? A1shortCodeOveride : shortcode;
  console.log("shortCodeOveride", shortCodeOveride);

  return (
    <>
      <MOLink
        className="mo-link"
        onClick={() => {
          tracker.advancedInFlow("click2sms", "click", {
            keyword: keywordOverride,
            shortcode: shortCodeOveride,
          });
        }}
        keywordAndShortcode={{
          keyword: keywordOverride,
          shortcode: shortCodeOveride,
        }}
      >
        <div className="label-mo">
          <FormattedMessage
            id="moLabel"
            defaultMessage="Click to send SMS message"
          />
        </div>
        <button className="btn">
          <FormattedMessage id="moButton" defaultMessage="Send SMS" />
        </button>

        <p className="mo-instructions">
          {/* <FormattedMessage id="moLabelSend" defaultMessage="Send" /> <b>{keyword}</b>{' '}
          <FormattedMessage id="moLabelTo" defaultMessage="to" /> <b>{shortcode}</b> */}
          <FormattedMessage id="replyWith" defaultMessage="Reply with" />{" "}
          <strong>
            <FormattedMessage id="yes" defaultMessage="DA" />
          </strong>
          {", "}
          <FormattedMessage
            id="toConfirmSubscription"
            defaultMessage="to confirm your subscription!"
          />
        </p>
      </MOLink>

      <Link
        className="link-try-again"
        onClick={() => {
          dispatch(backToStart());
          tracker.recedeInFlow(
            "tallyman.v1-pin",
            "MSISDN_ENTRY",
            "requested to change phone number"
          );
        }}
      >
        <FormattedMessage id="tryAgain" defaultMessage="Try again" />
      </Link>
    </>
  );
};

export default injectIntl(MO);
